import type { RouteRecordRaw } from 'vue-router'

export const appealsRoutes: RouteRecordRaw[] = [
  {
    path: '/appeals/new',
    name: 'appeals:new',
    component: () => import('./views/AppealFormView.vue'),
    meta: { title: 'Contester une décision de modération', requiresAuth: true },
  },
  {
    path: '/appeals/:uid',
    name: 'appeals:status',
    component: () => import('./views/AppealStatusView.vue'),
    meta: { title: "Suivi d'appel", requiresAuth: true },
    props: true,
  },
]
